/**
 * CSV Export utility component
 * Provides CSV generation functionality for statistics pages
 */

import React from 'react';
import { CSVLink } from 'react-csv';
import { 
  formatBusinessReviewStatsForCSV, 
  formatCharityReviewStatsForCSV,
  formatSocialImpactForCSV,
  formatAnalyticsForCSV,
  formatDateForFileName
} from './export';

// CSV Export Button Component
interface CsvExportButtonProps {
  data: any;
  filename?: string;
  dataType: 'business-review' | 'charity-review' | 'social-impact' | 'analytics';
  children: React.ReactNode;
}

const CsvExportButton: React.FC<CsvExportButtonProps> = ({ 
  data, 
  filename = 'report', 
  dataType,
  children 
}) => {
  const formattedDate = formatDateForFileName();
  const fullFilename = `${filename}-${formattedDate}.csv`;
  
  // Format data based on type
  const getCsvData = () => {
    switch (dataType) {
      case 'business-review':
        return formatBusinessReviewStatsForCSV(data);
      case 'charity-review':
        return formatCharityReviewStatsForCSV(data);
      case 'social-impact':
        return formatSocialImpactForCSV(data);
      case 'analytics':
        return formatAnalyticsForCSV(data);
      default:
        return [];
    }
  };

  return (
    <CSVLink 
      data={getCsvData()} 
      filename={fullFilename}
      style={{ textDecoration: 'none' }}
    >
      {children}
    </CSVLink>
  );
};

export default CsvExportButton;
